"use client";

import { useEffect, useRef } from "react";
import { useCurrentUrlWithoutHash } from "~/hooks/use-current-url-without-hash";
import { trackMetaBrowserPageViewWithRetry } from "~/lib/meta-browser";

/**
 * Tracks page views for Meta Pixel (browser-side).
 * GA4 page_view is handled automatically by gtag.js config.
 */
export function MetaPageView() {
  const currentUrl = useCurrentUrlWithoutHash();
  const lastUrl = useRef<string | null>(null);
  const retryController = useRef<AbortController | null>(null);

  useEffect(() => {
    if (!currentUrl || currentUrl === lastUrl.current) return;
    lastUrl.current = currentUrl;

    retryController.current?.abort();
    const controller = new AbortController();
    retryController.current = controller;

    void trackMetaBrowserPageViewWithRetry({ signal: controller.signal });

    return () => {
      controller.abort();
      if (retryController.current === controller) {
        retryController.current = null;
      }
    };
  }, [currentUrl]);

  return null;
}
